import filterObject from '../utils/filter';

const METRICS_TYPES = {
    integer: 'integer',
    string: 'string',
    comparison: 'comparison',
    float: 'float',
    currency: 'currency',
    percent: 'percent',
};

const DEFAULT_METRICS = {
    impressions: {
        label: gettext('Impressions'),
        value: 'impressions',
        type: METRICS_TYPES.integer,
    },
    clicks: {
        label: gettext('Clicks'),
        value: 'clicks',
        type: METRICS_TYPES.integer,
    },
    conversions: {
        label: gettext('Conversions'),
        value: 'conversions',
        type: METRICS_TYPES.float,
    },
    revenue: {
        label: gettext('Conversions Value'),
        value: 'revenue',
        type: METRICS_TYPES.currency,
    },
    cost: {
        label: gettext('Cost'),
        value: 'cost',
        type: METRICS_TYPES.currency,
    },
    cost_per_conversion: {
        label: gettext('Cost per Conversion'),
        value: 'cost_per_conversion',
        type: METRICS_TYPES.currency,
    },
    roas: {
        label: gettext('ROAS'),
        value: 'roas',
        type: METRICS_TYPES.float,
    },
    cpc: {
        label: gettext('CPC'),
        value: 'cpc',
        type: METRICS_TYPES.currency,
    },
    conv_value_conversion: {
        label: gettext('Conv Value / Conversion'),
        value: 'conv_value_conversion',
        type: METRICS_TYPES.currency,
    },
    cost_conv_value: {
        label: gettext('Cost / Conv Value'),
        value: 'cost_conv_value',
        type: METRICS_TYPES.currency,
    },
    conv_rate: {
        label: gettext('Conv Rate'),
        value: 'conv_rate',
        type: METRICS_TYPES.currency,
    },
};

const TAGGED_GROUP = {
    campaigns_tagged: {
        label: gettext('Campaigns Tagged'),
        value: 'campaigns_tagged',
        type: 'integer',
    },
};

const FACEBOOK_ADS_METRICS = {
    ...DEFAULT_METRICS,
    reach: {
        label: gettext('Reach'),
        value: 'reach',
        type: 'integer',
    },
};

const GOOGLE_ADS_METRICS = {
    ...DEFAULT_METRICS,
    videoviews: {
        label: gettext('Video Views'),
        value: 'videoviews',
        type: 'float',
    },
    videoviewrate: {
        label: gettext('Video View Rate'),
        value: 'videoviewrate',
        type: 'float',
    },
    averagecpv: {
        label: gettext('Avg CPV'),
        value: 'averagecpv',
        type: 'float',
    },
};

const CLIENT_METRICS = {
    impressions: DEFAULT_METRICS.impressions,
    clicks: DEFAULT_METRICS.clicks,
    cost: DEFAULT_METRICS.cost,
};

const GA_METRICS = {
    goalCompletion: {
        label: gettext('Goal Completion'),
        value: 'goalCompletion',
        type: 'integer',
    },
    cost_per_goal: {
        label: gettext('Cost Per Goal Completion'),
        value: 'cost_per_goal',
        type: 'integer',
    },
    transactions: {
        label: gettext('Transactions'),
        value: 'transactions',
        type: 'integer',
    },
    cost_per_transaction: {
        label: gettext('Cost per Transaction'),
        value: 'cost_per_transaction',
        type: 'integer',
    },
    transactionsRevenue: {
        label: gettext('Revenue'),
        value: 'transactionsRevenue',
        type: 'integer',
    },
    roi_ga: {
        label: gettext('ROI GA'),
        value: 'roi_ga',
        type: METRICS_TYPES.currency,
    },
    pageViews: {
        label: gettext('Page Views'),
        value: 'pageViews',
        type: 'integer',
    },
    sessions: {
        label: gettext('Sessions'),
        value: 'sessions',
        type: 'integer',
    },
    users: {
        label: gettext('Users'),
        value: 'users',
        type: 'integer',
    },
    newUsers: {
        label: gettext('New Users'),
        value: 'newUsers',
        type: 'integer',
    },
};

export const PARETO_ADS_METRICS = {
    pareto_ads_company_economy_man_hour: {
        label: gettext('Company Saved Hours with Pareto'),
        value: 'pareto_ads_company_economy_man_hour',
        type: METRICS_TYPES.float,
    },
    pareto_ads_my_economy_man_hour: {
        label: gettext('My Saved Hours with Pareto'),
        value: 'pareto_ads_my_economy_man_hour',
        type: METRICS_TYPES.float,
    },
};

export const PIPEDRIVE_METRICS = {
    deal_won_value: {
        label: gettext('Deals Won Value'),
        value: 'deal_won_value',
        type: METRICS_TYPES.currency,
    },
    deal_won: {
        label: gettext('Deals Won'),
        value: 'deal_won',
        type: METRICS_TYPES.integer,
    },
    pipedrive_cpa: {
        label: gettext('Pipedrive CPA'),
        value: 'pipedrive_cpa',
        type: METRICS_TYPES.currency,
    },
    pipedrive_roi: {
        label: gettext('Pipedrive ROI'),
        value: 'pipedrive_roi',
        type: METRICS_TYPES.currency,
    },
};

export const LOJA_INTEGRADA_METRICS = {
    average_ticket: {
        label: gettext('Average Ticket - Loja Integrada'),
        value: 'average_ticket',
        type: METRICS_TYPES.currency,
    },
    total_value: {
        label: gettext('Total Value - Loja Integrada'),
        value: 'total_value',
        type: METRICS_TYPES.currency,
    },
    order_quantity: {
        label: gettext('Order Quantity - Loja Integrada'),
        value: 'order_quantity',
        type: METRICS_TYPES.integer,
    },
};

const SHOPIFY_METRICS = {
    shopify_average_ticket: {
        label: gettext('Average Ticket - Shopify'),
        value: 'shopify_average_ticket',
        type: METRICS_TYPES.currency,
    },
    shopify_total_value: {
        label: gettext('Total Value - Shopify'),
        value: 'shopify_total_value',
        type: METRICS_TYPES.currency,
    },
    shopify_order_quantity: {
        label: gettext('Order Quantity - Shopify'),
        value: 'shopify_order_quantity',
        type: METRICS_TYPES.integer,
    },
};

const WOOCOMMERCE_METRICS = {
    woocommerce_average_ticket: {
        label: gettext('Average Ticket - Woocommerce'),
        value: 'woocommerce_average_ticket',
        type: METRICS_TYPES.currency,
    },
    woocommerce_total_value: {
        label: gettext('Total Value - Woocommerce'),
        value: 'woocommerce_total_value',
        type: METRICS_TYPES.currency,
    },
    woocommerce_order_quantity: {
        label: gettext('Order Quantity - Woocommerce'),
        value: 'woocommerce_order_quantity',
        type: METRICS_TYPES.integer,
    },
};

const ALL_METRICS = {
    ...DEFAULT_METRICS,
    ...FACEBOOK_ADS_METRICS,
    ...GOOGLE_ADS_METRICS,
    ...GA_METRICS,
};

const ALL_CURRENCYS_VALUE = filterObject(
    ALL_METRICS, metric => metric.type === 'currency',
);

export const PERCENTAGE_METRICS = [
    ALL_METRICS.conv_rate,
];

// Métricas que quanto menor, melhor
const INVERTED_COLOR_METRICS = [
    ALL_METRICS.cost_per_conversion.value,
    ALL_METRICS.cpc.value,
    ALL_METRICS.cost_conv_value.value,
];

export {
    ALL_METRICS,
    CLIENT_METRICS,
    DEFAULT_METRICS,
    FACEBOOK_ADS_METRICS,
    GOOGLE_ADS_METRICS,
    GA_METRICS,
    ALL_CURRENCYS_VALUE,
    INVERTED_COLOR_METRICS,
    TAGGED_GROUP,
    METRICS_TYPES,
    SHOPIFY_METRICS,
    WOOCOMMERCE_METRICS,
};
